import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getTopProducts } from '../../actions/topProductsAction';
import { getTopRevenueProducts } from '../../actions/topRevenueProductsAction';
import Spinner from '../Spinner';

const TopProducts = ({ topProducts, topRevenueProducts, getTopProducts, getTopRevenueProducts }: any) => {
  const [mode, setMode] = useState<'units' | 'revenue'>('units');

  useEffect(() => {
    getTopProducts();
    getTopRevenueProducts();
  }, []);

  const isUnits = mode === 'units';
  const list = isUnits ? topProducts.products : topRevenueProducts.products;
  const loading = isUnits ? topProducts.loading : topRevenueProducts.loading;
  const max = list[0] ? (isUnits ? list[0].totalQuantity : list[0].totalRevenue) : 1;

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Top 10 Products</p>
        <div className="top-products-toggle">
          <button
            className={`top-products-toggle-btn${isUnits ? ' active' : ''}`}
            onClick={() => setMode('units')}
          >
            Units sold
          </button>
          <button
            className={`top-products-toggle-btn${!isUnits ? ' active' : ''}`}
            onClick={() => setMode('revenue')}
          >
            Revenue
          </button>
        </div>
      </div>

      <div className="admin-card-body">
        {loading && (
          <div className="text-center py-4">
            <Spinner />
          </div>
        )}

        {!loading && list.length === 0 && (
          <div className="admin-empty-state">
            <i className="fas fa-box-open" />
            <p>No data yet</p>
          </div>
        )}

        {!loading && list.map((p: any, i: number) => {
          const value = isUnits ? p.totalQuantity : p.totalRevenue;
          const label = isUnits
            ? <>{p.totalQuantity} <span className="top-product-qty-label">sold</span></>
            : <>${p.totalRevenue.toFixed(0)}</>;
          return (
            <div key={p._id} className="top-product-row">
              <span className="top-product-rank">{i + 1}</span>
              {p.productImage && (
                <img src={p.productImage} alt={p.productName} className="top-product-img" />
              )}
              <div className="top-product-info">
                <p className="top-product-name">{p.productName}</p>
                <div className="top-product-bar-wrap">
                  <div
                    className={`top-product-bar${!isUnits ? ' top-product-bar-revenue' : ''}`}
                    style={{ width: `${(value / max) * 100}%` }}
                  />
                </div>
              </div>
              <span className="top-product-qty">{label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  topProducts: state.topProducts,
  topRevenueProducts: state.topRevenueProducts,
});

export default connect(mapStateToProps, { getTopProducts, getTopRevenueProducts })(TopProducts);
